export default __webpack_public_path__ + "static/explaining-3ad18c8b7d9a41a6931785022786005c.jpg";